$(document).on('submit', '.contactForm form#custom', function(e) { 
    $(this).addClass('loading-form');
    e.preventDefault(); 
    // Získání hodnot z formuláře
    var formData = {
        name: $('.contactForm form#custom #name').val(),
        email: $('.contactForm form#custom #email').val(),
        message: $('.contactForm form#custom #sprava').val()
    };

    // Přidání dat do FormData
    var formdata = new FormData();
    for (var key in formData) {
        formdata.append(key, formData[key]);
    }

    // Nastavení požadavku
    var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
    };

    // Odeslání dat na server
    fetch("https://tools.shopcode.cz/e-mail_sender/kamen-skalica/cz/www/", requestOptions)
    .then(response => response.json())
    .then(function(result){
        console.log(result.status);
        showMessage('Formulář byl úspěšně odeslaný, budeme vás kontaktovat.', 'success', '', false, true);
        if(result.status === 'ok'){
            $('.contactForm form').removeClass('loading-form');
            $('.contactForm form')[0].reset();
        }
    })
    .catch(function(){
        showMessage('Při odeslání nastala chyba. Zkuste to prosím znovu.', 'error', '', false, true);
        $('.contactForm form').removeClass('loading-form');
    });
})